// Re-export all English translations from modular files
// This file has been refactored into domain-specific modules

import { commonEn } from './en/common';
import { shippingEn } from './en/shipping';
import { vehicleEn } from './en/vehicle';
import { fuelEn } from './en/fuel';
import { pricingEn } from './en/pricing';
import { userEn } from './en/user';
import { reportsEn } from './en/reports';
import { systemEn } from './en/system';

export const en = {
  ...commonEn,
  ...shippingEn,
  ...vehicleEn,
  ...fuelEn,
  ...pricingEn,
  ...userEn,
  ...reportsEn,
  ...systemEn,
  // AI Model Configuration
  'ai.model.configuration': 'AI Model Configuration',
  'ai.models': 'AI Models',
  'add.ai.model': 'Add AI Model',
  'edit.ai.model': 'Edit AI Model',
  'model.name': 'Model Name',
  'model.description': 'Description',
  'model.purpose': 'Purpose',
  'selected.model': 'Selected',
  'select.model': 'Select',
  'ai.model.created': 'AI model created successfully',
  'ai.model.updated': 'AI model updated successfully',
  'ai.model.deleted': 'AI model deleted successfully',
  'ai.model.selected': 'AI model selected successfully',
  'confirm.delete.ai.model': 'Are you sure you want to delete this AI model?',
  'cannot.delete.selected.model': 'Cannot delete the currently selected AI model',
  'no.ai.models.available': 'No AI models available',
  'enter.model.name': 'Please enter model name',
  'select.model.purpose': 'Please select model purpose',

  // Model Purposes
  'model.purpose.document.type.detection': 'Document Type Detection',
  'model.purpose.document.processing': 'Document Processing (General)',
  'model.purpose.document.processing.pdf': 'Document Processing - PDF',
  'model.purpose.document.processing.image': 'Document Processing - Image',
  'model.purpose.telegram.chat': 'Telegram Chat',

  // Telegram
  'telegram.chat.model': 'Telegram Chat AI Model',
  'telegram.chat.model.active': 'This model handles Telegram bot chat responses with MCP tools.',
  'telegram.chat.model.not.configured': 'No Telegram Chat model selected',
  'telegram.chat.model.not.configured.desc': 'Add a TelegramChat AI model to enable intelligent chat responses.',
  'telegram.chat.model.available': 'available',
};
